import { FormControl, FormGroup, Validators } from "@angular/forms";
import { AuthService } from "../../../core/services";
import { ActivatedRoute, Router } from "@angular/router";
import { markAsTouched } from "../../utils";
import { Component, OnInit } from "@angular/core";

@Component({
  templateUrl: "./login-form.component.html",
  selector: "app-login-form",
})
export class LoginFormComponent implements OnInit {
  form = new FormGroup({
    number: new FormControl(null, [
      Validators.required,
      Validators.pattern(/^\d{4}-?\d{4}$/),
    ]),
    remember: new FormControl(),
  });

  error?: string;

  constructor(
    private auth: AuthService,
    private route: ActivatedRoute,
    private router: Router
  ) {}

  ngOnInit() {
    this.form.get("number").setValue(this.route.snapshot.params.number);
  }

  get number() {
    return this.form.get("number");
  }

  submit() {
    if (!this.form.valid) {
      return markAsTouched(this.form);
    }

    this.error = undefined;
    const debtNumber = this.form.get("number").value.replace("-", "");
    localStorage.setItem("customers_session", '{"timeout":{}}');
    this.auth.debtLookup(debtNumber).subscribe(
      ({ id, method, token }) => {
        if (method === "two-factor") {
          this.router.navigate(["/customers/login/two-factor", id]);
        } else if (method === "challenge") {
          this.router.navigate(["/customers/login/verify", id]);
        } else {
          this.router.navigate(["/customers/login/token/", token]);
        }
      },
      (err) => (this.error = err.status === 404 ? "not_found" : "unknown")
    );
  }
}



// WEBPACK FOOTER //
// ./src/app/shared/components/auth/login-form.component.ts